import customerInstance from './instance'

const getCustomer = (customerNumber) => {
	return customerInstance.get(`/customers/${customerNumber}`)
}

export default getCustomer
